import { render } from "./InvoiceDetailTabHistory.vue?vue&type=template&id=2f8f5af7"
import script from "./InvoiceDetailTabHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTabHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__